export default {
  methods: {
    checkPermission(permission) {
      return this.$store.state.permissions.some((e) => e === permission);
    },
  },
};
